<template>
  <button @click.prevent="destroy">Permanently Delete Team</button>
</template>

<script>
import DeleteTeamModal from './DeleteTeamModal';

export default {
    props: {
        team: {
            type    : Object,
            required: true,
        }
    },
    methods: {
        destroy() {
            Modal.show(DeleteTeamModal, {propsData: {
                team: this.team
            }}).then(response => {
                window.location = '/teams';
            }).catch(console.error);
        }
    }
}
</script>